module.exports = ".lista-margin {\n  margin-top: 2em;\n  margin-bottom: 1.2em; }\n"